import { render, staticRenderFns } from "./Sensorial.vue?vue&type=template&id=6233f148&scoped=true&lang=true"
import script from "./Sensorial.vue?vue&type=script&lang=js"
export * from "./Sensorial.vue?vue&type=script&lang=js"
import style0 from "./Sensorial.vue?vue&type=style&index=0&id=6233f148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233f148",
  null
  
)

export default component.exports